var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-frame"},[_c('div',{staticClass:"frame-box"},[_c('div',{staticClass:"goback-place"},[_c('c-go-back',{staticClass:"frame-go-back",attrs:{"backroute":_vm.bacroute,"title":""},on:{"click":_vm.closeForm}})],1),_c('iframe',{staticClass:"frame",attrs:{"src":_vm.url}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }